var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapModal',{attrs:{"modalNode":_vm.modalNode,"submitData":_vm.submitData,"close":_vm.close,"submit":_vm.submit,"title":_vm.roamingPointTitle,"id":"roamingPointEdit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }